import classNames from 'classnames';
import React from 'react';
import {
  isAllowedThroughLinkAccess,
  PostPolicyAction,
} from './postPolicyCheck';
import * as styles from './PostTitleWithIcons.module.scss';
import VerifiedIcon from './VerifiedIcon';
import SVGIcon from '../components/SVGIcon';
import TextWithIcon from '../components/TextWithIcon';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import publicIcon from '../icons/non-prefilled/16x16/public.svg';
import { UserRole } from '../topic/topicPolicyCheck';

const POST_FRAGMENT = gql(`
  fragment PostTitleWithIcons_post on RootPostFields {
    id
    title
    ...isAllowedThroughLinkAccess_post
    ... on SlimPostFields {
      verifiedAt
    }
  }
`);

type PostTitleWithIconsProps = {
  iconSize?: 'small' | 'regular';
  post: DocumentType<typeof POST_FRAGMENT>;
  showVerifiedIcon?: boolean;
  publicIconMuted?: boolean;
} & (
  | {
      truncate: true;
      title?: string;
    }
  | {
      truncate?: never;
      title?: React.ReactNode;
    }
);

const PostTitleWithIcons = ({
  iconSize = 'regular',
  post,
  title,
  truncate,
  showVerifiedIcon = true,
  publicIconMuted = false,
}: PostTitleWithIconsProps) => {
  const icon = (
    <>
      {showVerifiedIcon && 'verifiedAt' in post && !!post.verifiedAt && (
        <span className={classNames(styles.icon, styles[iconSize])}>
          <VerifiedIcon inline size={iconSize} />
        </span>
      )}
      {isAllowedThroughLinkAccess(
        PostPolicyAction.ViewPost,
        post,
        UserRole.Anonymous,
      ) && (
        <span
          className={classNames(styles.icon, styles[iconSize], {
            [styles.muted]: publicIconMuted,
          })}
        >
          <SVGIcon size={iconSize} inline>
            {publicIcon}
          </SVGIcon>
        </span>
      )}
    </>
  );

  if (truncate) {
    return <TextWithIcon text={title || post.title} icon={icon} truncate />;
  }

  return <TextWithIcon text={title || post.title} icon={icon} />;
};

export default PostTitleWithIcons;
